import React from "react";

export const Contact = (props) => {

  return (
    <div>
      <div id="contact" >
      <div className="container contact-container">
          <div className="row">
          <div className="contact-title">
           <h2>Contact Us</h2>
          </div>
            <div className="col-md-4 contact-item">
              <p>
                <span>
                  <i className="fa fa-map-marker"></i>
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="col-md-4 contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i>
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="col-md-4 contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i>
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
